import componentStyles from "../css/App.module.css";

export default function ProjectWidgetComponent(props) {
    return (
        <img className={componentStyles.projectContainer} src={props.imgSrc} alt={props.altText} />
    );
}